var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-criticality-card',{attrs:{"title":"SRC","fields":_vm.fields,"provider":_vm.provider,"enabled-levels":_vm.enabledLevels,"excel-file-name":"SRC"}})}
var staticRenderFns = []

export { render, staticRenderFns }